import refs from '../refs.js';
import {onMoreFromAuthorBtnClick} from '../scripts/more-from-this-author.js';

refs.modalCard.addEventListener('click', onMoreFromAuthorBtnClick)